import React, { Component } from "react";
import { MdMenu as MdMenuIcon } from "react-icons/md";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DoneIcon from "@material-ui/icons/Done";
import { Grid, IconButton } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
export default class SelectSheetPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false,
      isInputFocused: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async getAllSheets() {}

  handleClickOutside(event) {
    this.setState({
      popupVisible: false,
    });
  }

  handleLabelClick = () => {
    this.setState({
      popupVisible: true,
    });
  };

  render() {
    const LabelComponent = this.props.LabelComponent ? (
      React.cloneElement(this.props.LabelComponent, {
        onClick: this.handleLabelClick,
      })
    ) : (
      <ClickAwayListener onClickAway={this.handleClickOutside}>
        <IconButton
          style={{
            marginLeft: 20,
            marginRight: 10,
            maxHeight: 30,
          }}
          onClick={this.handleLabelClick}
        >
          <MdMenuIcon className="heading h-100" />
        </IconButton>
      </ClickAwayListener>
    );
    // console.log(LabelComponent);
    return (
      <div
        className="align-self-center"
        style={{
          textAlign: "center",
          fontSize: 20,
        }}
      >
        {LabelComponent}
        <div
          style={{
            display: this.state.popupVisible ? "flex" : "none",
            justifyContent: "center",
          }}
        >
          <div className="sheetMenu">
            <Autocomplete
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              options={this.props.sheets.map((sheet) => sheet.name)}
              onChange={(event, newValue) => {
                this.props.onChange(
                  this.props.sheets.find((sheet) => sheet.name === newValue)
                );
                this.setState({
                  popupVisible: false,
                });
              }}
              value={this.props.selectedSheet?.value}
              openOnFocus={true}
              autoHighlight={true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={(input) => input && input.focus()}
                  onBlur={this.props.isLookupPopup && this.handleClickOutside}
                  label="Find a sheet"
                  margin="dense"
                  variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              renderOption={(sheet, index) => {
                return (
                  <React.Fragment>
                    <DoneIcon
                      className="selectedSheetMenuIcon"
                      style={{
                        visibility:
                          this.props.selectedSheet.name === sheet
                            ? "visible"
                            : "hidden",
                      }}
                    />
                    <div className="sheetMenuName">{sheet}</div>
                  </React.Fragment>
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
